import { render, staticRenderFns } from "./svgDivar.vue?vue&type=template&id=45fe4f40&scoped=true"
import script from "./svgDivar.vue?vue&type=script&lang=js"
export * from "./svgDivar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45fe4f40",
  null
  
)

export default component.exports